module.exports = __webpack_public_path__ + "media/images/logotipo-3fa35ca95de4dd996290fadbd2d924df.jpg";